angular.module('dnecom')
    .directive('validationZone', ["$parse", "$timeout", function ($parse, $timeout) {
        var isColliding = function (zone1, zone2) {
            if (zone1.id == zone2.id) {
                return false;
            }

            for (var i = 0; i < zone1.countries.length; i++) {
                for (var j = 0; j < zone2.countries.length; j++) {
                    var country1 = zone1.countries[i];
                    var country2 = zone2.countries[j];

                    if (country1.code == country2.code) {
                        if (!country1.states.length || !country2.states.length) {
                            return {
                                'country': country1.name
                            };
                        }

                        var state = (function (array1, array2) {
                            for (var i = 0; i < array1.length; i++) {
                                for (var j = 0; j < array2.length; j++) {
                                    if (array1[i].code == array2[j].code) {
                                        return array1[i].name;
                                    }
                                }

                                return false;
                            }
                        })(country1.states, country2.states);

                        if (state) {
                            return {
                                'country': country1.name,
                                'state': state
                            };
                        }
                    }
                }
            }

            return false;
        }

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                ngModelController.$validators.validationZone = function (modelValue, viewValue) {
                    var zones = $parse(attrs.validationZone)(scope);

                    if (ngModelController.$isEmpty(modelValue)) {
                        return true;
                    }

                    var clearAfterTimeout = $timeout(function() {
                        ngModelController.$rollbackViewValue();
                        ngModelController.$modelValue = null;
                    }, 3000);

                    var isValid = _.every(zones, function (zone) {
                        return !isColliding(zone, viewValue);
                    });
                    
                    if (isValid) {
                        $timeout.cancel(clearAfterTimeout);
                    }
                    
                    return isValid;
                }
            }
        }
    }]);
